import React from 'react';
import CellAbstract from './CellAbstract';
import { Position } from '../../../dispatcher/Types';
import { CELL_ROUTE_LINK_PROPS } from './Types';

/**
 * This Component is used to going to another route and
 * if `filterDataMap`(from `actionData` object) is not empty to filter grid of desired route dashboard
 */
class CellRouteLink extends CellAbstract<CELL_ROUTE_LINK_PROPS, {}> {
  private onClickHandler = (e) => {
    e.preventDefault();
    const {
      dataItem,
      cellConfig
    } = this.props;

    const { actionName = 'changeDashboardRoute', actionData = {} as any } = cellConfig;
    const filterDataMap = actionData?.filterDataMap;
    const filterData = {};
    if (filterDataMap) {
      filterDataMap.forEach((item) => {
        filterData[item.filterFieldName] = {
          values: [dataItem[item.valueFieldName]]
        };
      });
      actionData.filterData = { ...filterData };
    }
    this.dispatch(actionName, Position.end, actionData);
  }

  render() {
    const {
      dataIndex,
      dataItem,
      field
    } = this.props;

    const text = dataItem[(field || dataIndex)];

    return this.renderCell(
      (Number(text) === 0) ? <span>
        {text}
      </span> : <a
        className="tp-link"
        onClick={this.onClickHandler}
        tabIndex={0}
      >
        {text}
      </a>
    );
  }
}

export default CellRouteLink;
